import { Component, OnInit } from '@angular/core';
import { AppSettingsService } from '@core/services/app-settings.service';
import { environment } from 'src/environments/environment';

import { AppMainComponent } from './app.main.component';
import { SessionUserService } from './security/services/session-user.service';
import { AppNavItem } from 'projects/lib-web-layout-templates/src/lib/models';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {

    model: any[];
    authorities: string[];
    environment = environment;
    navItems: AppNavItem[] = [];
    logo: string = "logo.png";
    isLoader: boolean = false;

    constructor(public appMain: AppMainComponent, private appSettingsService: AppSettingsService, private sessionUserService: SessionUserService) { }

    ngOnInit() {
        this.getNavItems();
    }

    getNavItems() {
        this.appSettingsService.rawNavchildren.then(items => {
            this.navItems =  items;
            this.authorities = this.sessionUserService.userSession.authorities;
          }).finally(() =>{
              this.isLoader = true;
          })


    }

}
